<div class="container navbar-class fixed-top">
    <app-nav-admin></app-nav-admin>
</div>
<router-outlet></router-outlet>